import { graphql } from 'relay-runtime';

export const PROFILE_BADGES_QUERY = graphql`
  query ProfileBadgesQuery($username: String, $internalId: String) {
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
        ... on UnifiedProfile {
          id
          aaid
          isProfileOwnerConsented
          learning {
            ... on UnifiedQueryError {
              identifier
              message
              extensions {
                errorType
                statusCode
              }
            }
            ... on UnifiedLearning {
              id
              recentCoursesBadges {
                ... on UnifiedProfileBadgesConnection {
                  edges {
                    node {
                      actionUrl
                      description
                      id
                      imageUrl
                      lastCompletedDate
                      name
                      type
                    }
                  }
                  totalCount
                }
              }
            }
            ... on UnifiedQueryError {
              identifier
              message
              extensions {
                errorType
                statusCode
              }
            }
          }
          badges {
            ... on UnifiedProfileBadgesConnection {
              edges {
                node {
                  actionUrl
                  description
                  id
                  imageUrl
                  lastCompletedDate
                  name
                  type
                }
              }
              totalCount
            }
            ... on UnifiedQueryError {
              identifier
              message
              extensions {
                errorType
                statusCode
              }
            }
          }
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
